class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.containerElement = document.querySelector("#product-grid");
    this.paginationNextElement = document.querySelector("#PaginationNext");
    this.paginationPrevElement = document.querySelector("#PaginationPrev");
    this.checkForCursor();

    window.addEventListener("pageshow", () => {
      this.checkForCursor();
    });

    const url = new URL(window.location.href);

    if (!url.searchParams.get("page")) {
      url.searchParams.set("page", "1");
    }

    if (url.searchParams.get("cursor")) {
      url.searchParams.delete("cursor");
    }

    window.history.replaceState(
      {
        ...window.history.state,
        searchParams: window.location.search.slice(1),
        [url.toString()]: this.innerHTML,
      },
      ""
    );

    const { userAgent } = navigator;
    this.useLegacyPagination =
      userAgent.includes("iPhone OS 13") ||
      userAgent.includes("iPhone OS 12") ||
      userAgent.includes("iPhone OS 11") ||
      userAgent.includes("iPhone OS 10");

    if (!this.useLegacyPagination) {
      this.querySelector(".paginate-button__wrapper").style.display = "none";
    }
  }

  connectedCallback() {
    if (!this.useLegacyPagination) {
      this.listenForLoadPrev();
      this.listenForLoadNext();
    }
  }

  getSectionId() {
    return document.getElementById("product-grid").dataset.id;
  }

  checkForCursor() {
    const url = new URL(window.location.href);
    const cursor = url.searchParams.get("cursor");

    if (cursor) {
      const anchor = this.containerElement.querySelector(
        `[data-id="${cursor}"]`
      );

      if (
        anchor &&
        anchor.getBoundingClientRect().bottom > window.innerHeight
      ) {
        anchor.scrollIntoView(false, { block: "center" });
      }
    }
  }

  listenForLoadNext() {
    const handleIntersection = (entries) => {
      if (!entries[0].isIntersecting) return;

      this.nextPageLinkElement = this.paginationNextElement.querySelector("a");
      if (this.nextPageLinkElement) {
        this.nextPageLinkElement.classList.remove("hidden");
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.loadNext();
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this.paginationNextElement);
  }

  listenForLoadPrev() {
    const handleIntersection = (entries) => {
      if (!entries[0].isIntersecting) return;

      this.prevPageLinkElement = this.paginationPrevElement.querySelector("a");
      if (this.prevPageLinkElement) {
        this.prevPageLinkElement.classList.remove("hidden");
        this.prevPageUrl = this.prevPageLinkElement.href;
        this.loadPrevious();
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      this.paginationPrevElement
    );
  }

  loadNext() {
    const updatePage = (html) => {
      const newItems = html.querySelector("#product-grid");
      var newPagination = html.querySelector("#PaginationNext");

      this.containerElement.insertAdjacentHTML("beforeend", newItems.innerHTML);

      this.paginationNextElement.innerHTML = newPagination.innerHTML;
    };

    const cachedPage =
      window.history.state && window.history.state[this.nextPageUrl];

    if (cachedPage) {
      updatePage(new DOMParser().parseFromString(cachedPage, "text/html"));
    } else {
      fetch(`${this.nextPageUrl}&section_id=${this.getSectionId()}`)
        .then((response) => response.text())
        .then((responseText) => {
          const newPage = new DOMParser()
            .parseFromString(responseText, "text/html")
            .querySelector("infinite-scroll");

          updatePage(newPage);
          window.history.replaceState(
            {
              ...window.history.state,
              [this.nextPageUrl]: newPage.innerHTML,
            },
            ""
          );
        });
    }
  }

  loadPrevious() {
    const updatePage = (html) => {
      const newItems = html.querySelector("#product-grid");
      var newPagination = html.querySelector("#PaginationPrev");

      const firstItem = this.containerElement.firstElementChild;

      const initialOffset = firstItem.getBoundingClientRect().top;

      const intialScrollPosition = window.scrollY;

      this.containerElement.insertAdjacentHTML(
        "afterbegin",
        newItems.innerHTML
      );

      if (firstItem) {
        history.scrollRestoration = "manual";

        window.scrollTo(
          0,
          firstItem.getBoundingClientRect().top +
            -initialOffset +
            intialScrollPosition
        );
      }

      this.paginationPrevElement.innerHTML = newPagination.innerHTML;
    };

    const cachedPage =
      window.history.state && window.history.state[this.prevPageUrl];

    if (cachedPage) {
      updatePage(new DOMParser().parseFromString(cachedPage, "text/html"));
    } else {
      fetch(`${this.prevPageUrl}&section_id=${this.getSectionId()}`)
        .then((response) => response.text())
        .then((responseText) => {
          const newPage = new DOMParser()
            .parseFromString(responseText, "text/html")
            .querySelector("infinite-scroll");

          updatePage(newPage);

          window.history.replaceState(
            {
              ...window.history.state,
              [this.prevPageUrl]: newPage.innerHTML,
            },
            ""
          );
        });
    }
  }
}

customElements.define("infinite-scroll", InfiniteScroll);

class PageCursor extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.closest("infinite-scroll").useLegacyPagination) return;

    const handleIntersection = (entries) => {
      if (!entries[0].isIntersecting) return;

      const url = new URL(window.location.href);

      const currentPage = url.searchParams.get("page") || 1;
      const newPage = this.closest("[data-page]").dataset.page;

      if (newPage == currentPage) return;

      if (newPage == 1) {
        url.searchParams.delete("page");
      } else {
        url.searchParams.set("page", newPage);
      }

      url.searchParams.delete("cursor");

      history.scrollRestoration = "auto";

      window.history.replaceState(
        {
          ...window.history.state,
          searchParams: url.searchParams.toString(),
        },
        "",
        url.toString()
      );
      document
        .querySelectorAll("facet-filters-form")
        .forEach(
          (form) => (form.searchParamsPrev = url.searchParams.toString())
        );
    };

    const marginOffset =
      this.closest("li").clientHeight - window.innerHeight + 60;

    const rootMargin =
      this.dataset.position === "start"
        ? `0px 0px ${marginOffset}px 0px`
        : `${marginOffset}px 0px 0px 0px`;

    new IntersectionObserver(handleIntersection.bind(this), {
      threshold: 1,
      rootMargin,
    }).observe(this);
  }
}

customElements.define("page-cursor", PageCursor);

class AppendCursor extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.closest("infinite-scroll").useLegacyPagination) return;

    const links = this.querySelectorAll("a");

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        const url = new URL(window.location.href);

        url.searchParams.set("cursor", this.closest("[data-id]").dataset.id);
        url.searchParams.set("page", this.closest("[data-id]").dataset.page);

        window.history.replaceState(
          {
            ...window.history.state,
            searchParams: url.searchParams.toString(),
          },
          "",
          url.toString()
        );
        history.scrollRestoration = "manual";
        document
          .querySelectorAll("facet-filters-form")
          .forEach(
            (form) => (form.searchParamsPrev = url.searchParams.toString())
          );
      });
    });
  }
}

customElements.define("append-cursor", AppendCursor);
